import { EventBus } from '#shared'
import type { Message } from '#entities/message'

type ChatId = number

type MessageEditEventBus = Record<ChatId, (message: Message | null) => void>

export const messageEditEventBus = new EventBus<MessageEditEventBus>()
